/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Transfer_Dialog_Name_ConflictInputs */



/**
* | output |
* | --- |
* | "An artifact named \"{name}\" already exists in the target project." |
*
* @param {Transfer_Dialog_Name_ConflictInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const transfer_dialog_name_conflict = /** @type {((inputs: Transfer_Dialog_Name_ConflictInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transfer_Dialog_Name_ConflictInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ein Artefakt mit dem Namen "${i?.name}" existiert bereits im Zielprojekt.`)
	return /** @type {LocalizedString} */ (`An artifact named "${i?.name}" already exists in the target project.`)
});